module.exports = __webpack_public_path__ + "static/media/ticketPriority.5801ce6d.svg";